/**
 * Utility functions for the application
 */

/**
 * Validates email format
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * Formats a number with commas
 */
export function formatNumber(num: number): string {
  return num.toLocaleString()
}

/**
 * Truncates text to a specified length
 */
export function truncate(text: string, length: number): string {
  if (text.length <= length) return text
  return text.slice(0, length) + '...'
}

/**
 * Delays execution for a specified time
 */
export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * Combines class names conditionally
 */
export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function formatMoney(amountMinor: number, currency: string): string {
  const fractionDigits = (() => {
    try {
      return (
        new Intl.NumberFormat(undefined, { style: 'currency', currency }).resolvedOptions()
          .maximumFractionDigits ?? 2
      )
    } catch {
      return 2
    }
  })()
  const major = amountMinor / Math.pow(10, fractionDigits)
  return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(major)
}

export function formatBillingCycle(cycle: 'MONTHLY' | 'ANNUAL'): string {
  return cycle === 'ANNUAL' ? 'Annual' : 'Monthly'
}
